<template>
    <Page :header="content[lang_].title" :header_pos="'center'">
        <template #body>
            <div class="flex w-full justify-content-center align-items-center">
                <Button :label="content[lang_].main" @click="$router.push({path: '/'})" />
            </div>
        </template>
    </Page>
</template>

<script>
import Page from '@/components/sides/Page.vue'

export default {
    data() {
        return {
            content:{
                en: {
                    title: "Not Found",
                    main: "To home",
                } ,
                ru: {
                    title: "Нет такой страницы",
                    main: "На главную",
                }
            },
        }
    },
    components: {
        Page
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' }
    },
}
</script>